import io from "socket.io-client";
import { setRoomId, setParticipants, setSocketId } from "../store/actions";
import store from "../store/store";
import * as webRTCHandler from "./webRTCHandler";
import { appendNewMessageToChatHistory } from "./directMessages";



//const SERVER = "https://binosphere.com:8081";
const SERVER = process.env.REACT_APP_API_URL;
//const SERVER = "http://localhost:5005";

let socket = null;

console.log(SERVER,"xxx");

export const connectWithSocketIOServer = () => {
  socket = io(SERVER);

  socket.on("connect", () => {
    console.log("successfully connected with socket io server");
    console.log(socket.id);
    store.dispatch(setSocketId(socket.id));
  });

  socket.on("room-id", (data) => {
    const { roomId } = data;
    store.dispatch(setRoomId(roomId));
  });

  socket.on("room-update", (data) => {
    const { connectedUsers } = data;
    console.log("all the people involved",connectedUsers);

    store.dispatch(setParticipants(connectedUsers));
  });
  
  socket.on("participants-update", (data) => {
    console.log("participants-update",data);

    store.dispatch(setParticipants(data));
  });

  socket.on("conn-prepare", (data) => {
    const { connUserSocketId } = data;

    console.log("XXX",connUserSocketId);

    webRTCHandler.prepareNewPeerConnection(connUserSocketId, false);

    // inform the user which just join the room that we have prepared for incoming connection
    socket.emit("conn-init", { connUserSocketId: connUserSocketId });
  });

  socket.on("conn-signal", (data) => {
    webRTCHandler.handleSignalingData(data);
  });

  socket.on("conn-init", (data) => {
    const { connUserSocketId } = data;
    webRTCHandler.prepareNewPeerConnection(connUserSocketId, true);
  });

  socket.on("user-disconnected", (data) => {
    webRTCHandler.removePeerConnection(data);
  });

  socket.on("direct-message", (data) => {
    
  console.log(data)
    appendNewMessageToChatHistory(data);
  });
};

export const createNewRoom = (identity, onlyAudio, roomId) => {
  // emit an event to server that we would like to create new room
  const data = {
    identity,
    onlyAudio,
    roomId
  };

  socket.emit("create-new-room", data);
};

export const joinRoom = (identity, roomId, onlyAudio) => {
  //emit an event to server that we would to join a room
  const data = {
    roomId,
    identity,
    onlyAudio,
  };

  socket.emit("join-room", data);
};

export const signalPeerData = (data) => {
  socket.emit("conn-signal", data);
};

export const sendDirectMessage = (data) => {
  socket.emit("direct-message", data);
};

export const updateParticipants = (data) => {
  console.log(data)
  socket.emit("participants-update", data);
};
